export var regionGroupToLocalities = regionGroup => {
  var localities = [];
  if (regionGroup.region) {
    localities.push(regionGroup.region);
  }
  if (regionGroup.nearbyDistricts) {
    localities.push(...regionGroup.nearbyDistricts);
  }
  return localities;
};
var buildLocalityName = function buildLocalityName(locality) {
  var withState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var name = locality.name;
  if (withState) {
    var _locality$metaData;
    var state = (_locality$metaData = locality.metaData) === null || _locality$metaData === void 0 ? void 0 : _locality$metaData.state;
    if (state) {
      name += ", ".concat(state);
    }
  }
  return name;
};
export var regionGroupToOptions = (regionGroup, aliases, options) => {
  var result = aliases.map(alias => ({
    label: alias.name,
    value: alias.slug
  }));
  if (!result.length) {
    result.push({
      label: buildLocalityName(regionGroup.region, options === null || options === void 0 ? void 0 : options.withState),
      value: regionGroup.region.slug,
      id: regionGroup.region.id,
      type: regionGroup.region.type
    });
  }
  regionGroup.districts.forEach(district => {
    result.push({
      label: buildLocalityName(district, options === null || options === void 0 ? void 0 : options.withState),
      value: district.slug,
      id: district.id,
      type: district.type
    });
  });
  if (regionGroup.nearbyDistricts.length) {
    result.push({
      label: 'Nearby Districts',
      value: '---',
      disabled: true
    });
    regionGroup.nearbyDistricts.forEach(district => {
      result.push({
        label: buildLocalityName(district, options === null || options === void 0 ? void 0 : options.withState),
        value: district.slug,
        indented: true,
        id: district.id,
        type: district.type
      });
    });
  }
  return result;
};